module.exports = __webpack_public_path__ + "img/screenshot_board_2_super_pos_tooltip.63b52465.png";